<template>
  <div v-if="error" class="cr-container">
    <div class="cr-detail-card__message cr-message cr-message--error" v-html="error"></div>
  </div>
</template>
<script>
export default {
  props: {
    error: {
      type: String,
      required: true
    },
  },
}
</script>